module.exports = __webpack_public_path__ + "static/media/15-Hannover.d1bdce2e.jpg";